import "core-js/modules/web.dom.iterable";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.function.name";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { AbstractFeatureLoader } from './AbstractFeatureLoader';
import { Logger } from './logger';
export var LocalFeatureLoader =
/*#__PURE__*/
function (_AbstractFeatureLoade) {
  _inherits(LocalFeatureLoader, _AbstractFeatureLoade);

  function LocalFeatureLoader() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LocalFeatureLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalFeatureLoader).call(this));

    _defineProperty(_assertThisInitialized(_this), "features", void 0);

    _defineProperty(_assertThisInitialized(_this), "rules", void 0);

    _defineProperty(_assertThisInitialized(_this), "logger", void 0);

    _defineProperty(_assertThisInitialized(_this), "defaultFeatureValue", void 0);

    _defineProperty(_assertThisInitialized(_this), "isSetup", void 0);

    _defineProperty(_assertThisInitialized(_this), "isFailure", void 0);

    _defineProperty(_assertThisInitialized(_this), "featureListeners", []);

    var _options$features = options.features,
        features = _options$features === void 0 ? {} : _options$features,
        _options$rules = options.rules,
        rules = _options$rules === void 0 ? {} : _options$rules,
        _options$defaultFeatu = options.defaultFeatureValue,
        defaultFeatureValue = _options$defaultFeatu === void 0 ? false : _options$defaultFeatu,
        _options$loggingLevel = options.loggingLevel,
        loggingLevel = _options$loggingLevel === void 0 ? 'none' : _options$loggingLevel,
        localMode = options.localMode,
        onSetupComplete = options.onSetupComplete;
    _this.logger = new Logger(loggingLevel);

    _this.logger.info('setting up basic feature provider with options', options);

    _this.defaultFeatureValue = defaultFeatureValue;
    _this.features = features;
    _this.rules = rules;

    if (localMode) {
      var _localMode$features = localMode.features,
          localFeatures = _localMode$features === void 0 ? {} : _localMode$features,
          _localMode$rules = localMode.rules,
          localRules = _localMode$rules === void 0 ? {} : _localMode$rules;
      _this.features = localFeatures;
      _this.rules = localRules;
    }

    _this.initRuntimeTool();

    if (onSetupComplete) {
      onSetupComplete();
    }

    _this.isSetup = true;
    _this.isFailure = false;
    return _this;
  }

  _createClass(LocalFeatureLoader, [{
    key: "getFeature",
    value: function getFeature(name) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.logger.debug("getting feature ".concat(name, " with context ").concat(_JSON$stringify(context)));
      var _options$defaultValue = options.defaultValue,
          defaultValue = _options$defaultValue === void 0 ? this.defaultFeatureValue : _options$defaultValue;
      var enabled = defaultValue;

      if (this.rules.hasOwnProperty(name)) {
        enabled = this.rules[name](context);
      } else if (this.features.hasOwnProperty(name)) {
        enabled = this.features[name];
      }

      return {
        name: name,
        enabled: enabled
      };
    }
  }, {
    key: "addFailureListener",
    value: function addFailureListener(listener) {
      listener();
      return {
        changeListener: function changeListener() {}
      };
    }
  }, {
    key: "removeFailureListener",
    value: function removeFailureListener() {}
  }, {
    key: "addFeatureListener",
    value: function addFeatureListener(listener) {
      this.featureListeners.push(listener);
      listener();
      return {
        changeListener: function changeListener() {}
      };
    }
  }, {
    key: "removeFeatureListener",
    value: function removeFeatureListener() {}
  }, {
    key: "getAllFeatures",
    value: function getAllFeatures(context, options) {
      var _this2 = this;

      return _Object$keys(this.features).map(function (key) {
        return _this2.getFeature(key, context, options);
      });
    }
  }, {
    key: "initRuntimeTool",
    value: function initRuntimeTool() {
      var featureListeners = this.featureListeners;
      var features = this.features;

      if (window && !window.ORIGIN_FEATURES) {
        window.ORIGIN_FEATURES = {
          updateFeatures: function updateFeatures(enabled, featureNames) {
            featureNames.forEach(function (featureName) {
              features[featureName] = enabled;
            });
            featureListeners.forEach(function (listener) {
              return listener();
            });
          },
          enableFeatures: function enableFeatures(featureNames) {
            this.updateFeatures(true, featureNames);
          },
          disableFeatures: function disableFeatures(featureNames) {
            this.updateFeatures(false, featureNames);
          },
          enableFeature: function enableFeature(featureName) {
            this.enableFeatures([featureName]);
          },
          disableFeature: function disableFeature(featureName) {
            this.disableFeatures([featureName]);
          }
        };
      }
    }
  }]);

  return LocalFeatureLoader;
}(AbstractFeatureLoader);